import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { setProfile } from "features/ProfileSlice";

import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  isNewApiEnabled,
  loadCustomerProfileToStore,
} from "services/Api/customerProfileFetch";
import {
  fetchStreakCampaignActive,
  loadStreakProgressToStore,
} from "services/Api/streakProgressFetch";
import Menu from "pages/menuMain/menu";
import Banners from "pages/centerComponent/Banners";
import moment from "moment";
import FlavorEvent from "pages/centerComponent/FlavorEvent";
import StreakChallengeBanner, {
  resolveStreakBannerStampCount,
} from "../../components/StreakChallengeBanner";
import { shouldShowStreakTodayOverlay } from "../../utils/streakDisplay";
import StreakHowToPopup from "../../components/StreakHowToPopup";
import StreakRewardPopup from "../../components/StreakRewardPopup";

const Collectpoint = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const stateProfile = useSelector((state) => state.profile.dataUser);
  const [showStreakHowToPopup, setShowStreakHowToPopup] = useState(false);
  const [showStreakChallengeBanner, setShowStreakChallengeBanner] =
    useState(false);
  const [streakRewardPopupType, setStreakRewardPopupType] = useState(
    () => location.state?.streakPopupType ?? null,
  );

  const incomingStreakChallenge = location.state?.streakChallenge ?? null;

  const streakProfile = {
    ...stateProfile,
    pointView: {
      ...stateProfile.pointView,
      streakChallenge:
        incomingStreakChallenge ??
        stateProfile.pointView?.streakChallenge ??
        stateProfile.pointView?.streak_challenge,
    },
  };

  const streakBannerStampCount = resolveStreakBannerStampCount(streakProfile);

  const showStreakTodayRewardOverlay =
    shouldShowStreakTodayOverlay(streakProfile.pointView?.streakChallenge);

  useEffect(() => {
    let cancelled = false;

    const refreshBanner = async () => {
      if (!isNewApiEnabled()) {
        if (!cancelled) {
          setShowStreakChallengeBanner(false);
        }
        return;
      }

      const streakRes = await fetchStreakCampaignActive();
      if (!cancelled) {
        setShowStreakChallengeBanner(Boolean(streakRes.active));
      }
    };

    refreshBanner();
    const intervalId = setInterval(refreshBanner, 10000);
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        refreshBanner();
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", refreshBanner);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", refreshBanner);
    };
  }, []);

  const closeStreakRewardPopup = () => {
    setStreakRewardPopupType(null);
    navigate(location.pathname, { replace: true, state: {} });
  };

  useEffect(() => {
    const fetchProfile = async () => {
      const customerId = stateProfile.customerId || stateProfile.id;
      if (!customerId) return;

      const savedActionPoint = stateProfile.actionPoint;
      const profileRes = await loadCustomerProfileToStore({
        dispatch,
        customerId,
      });

      if (profileRes.applied && savedActionPoint != null) {
        dispatch(setProfile({ actionPoint: savedActionPoint }));
      }

      if (incomingStreakChallenge) {
        dispatch(
          setProfile({
            pointView: {
              ...(profileRes.result?.pointView ?? stateProfile.pointView),
              streakChallenge: incomingStreakChallenge,
            },
          }),
        );
      }

      if (isNewApiEnabled()) {
        await loadStreakProgressToStore({
          dispatch,
          customerId,
          existingPointView:
            profileRes.result?.pointView ?? stateProfile.pointView,
        });
      }

      console.log("after-custormerProfile", profileRes);
    };
    fetchProfile();
  }, []);

  // console.log("stateProfile => ", stateProfile);
  return (
    <div>
      <Helmet>
        <title>โคอะลา มาร์ช</title>
        <meta name="title" content="โคอะลา มาร์ช" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="โคอะลา มาร์ช" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>
      <>
        <div id="pageScan-Collectpoint">
          <main>
            <div className="wrapContent">
              <section id="pPointTop">
                <h1 className="bTitle">Collect points</h1>
                <div className="bPoint">
                  <p>Koala’s March point ของคุณ</p>
                  <div className="bTotalPoint">
                    <span>{stateProfile.currentPoint}</span>
                  </div>
                  <p>หมดอายุ 31 ธันวาคม {Number(moment().format("YYYY")) + 543}</p>
                </div>
              </section>
              <section id="pCollectpoint">
                <div className="bCollectpoint">
                  <div className="bPoint">
                    <p>คุณได้รับ Points</p>
                    <div className="bTotalPoint">
                      <span>{stateProfile.actionPoint}</span>
                    </div>
                  </div>
                  <FlavorEvent currentPoint={stateProfile.currentPoint} point={stateProfile.point} />
                  <div className="bLink">
                    <a onClick={() => navigate("/history-collect-point")}>ประวัติการ Collect point</a>
                  </div>
                </div>
              </section>

              {/* Streak Challenge */}
              {showStreakChallengeBanner && (
                <section id="pStreakChallenge" style={{ padding: "0 16px" }}>
                  <StreakChallengeBanner
                    currentStreak={streakBannerStampCount}
                    showTodayRewardOverlay={showStreakTodayRewardOverlay}
                    onHowToClick={() => setShowStreakHowToPopup(true)}
                  />
                </section>
              )}

              <section id="bButton">
                <div className="bBtn">
                  <a onClick={() => navigate("/scanpoint")} className="btn">
                    กรอกโค้ดเพิ่ม
                  </a>
                  <a onClick={() => navigate("/reward")} className="btn outline">
                    แลกของรางวัล
                  </a>
                </div>
              </section>
              <section id="pBanner">
                <Banners currentPage="Scan results" />
              </section>
              <Menu />

              {showStreakHowToPopup && (
                <StreakHowToPopup onClose={() => setShowStreakHowToPopup(false)} />
              )}

              {streakRewardPopupType && (
                <StreakRewardPopup
                  type={streakRewardPopupType}
                  onClose={closeStreakRewardPopup}
                />
              )}

              {/* <!-- Menu -->
          <?php include 'inc/inc-menu.php';?>

          <!-- Modal -->
          <?php include 'inc/inc-modal.php';?> */}
            </div>
          </main>
        </div>
      </>
    </div>
  );
};

export default Collectpoint;
